module.exports = __webpack_public_path__ + "static/media/mikeheadshot.57af305b.jpg";